export default "/static/dashboard/build/app/img/v2/946939b4efc5b6701b9d5962f0b91e81.png";